module.exports = __webpack_public_path__ + "static/media/kids_26.0c365c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_26.jpg
// module id = 5882
// module chunks = 0